// Runtime configuration. Values can be overridden per-embed with
// `window.TM_DESIGNER = { apiBase, productHandle, mapboxToken }` before the script loads.
interface DesignerConfig {
  apiBase: string;
  productHandle: string;
  mapboxToken: string;
  assetBase: string;
}

declare global {
  interface Window {
    TM_DESIGNER?: Partial<DesignerConfig>;
  }
}

const overrides = (typeof window !== 'undefined' && window.TM_DESIGNER) || {};

export const config: DesignerConfig = {
  apiBase: overrides.apiBase ?? import.meta.env.VITE_API_BASE ?? '/api',
  productHandle: overrides.productHandle ?? 'design-your-own-trail-map',
  // Public (pk.) token, the same one the current live builder ships with.
  mapboxToken:
    overrides.mapboxToken ??
    import.meta.env.VITE_MAPBOX_TOKEN ??
    'pk.eyJ1IjoidHJhaWxtYXBzdWsiLCJhIjoiY2sybjI3M2FpMDlkbzNtbnZrNzF6emtuZyJ9.DuL81krriZaK7daNSKYVhw',
  assetBase: overrides.assetBase ?? import.meta.env.BASE_URL,
};

export const asset = (path: string) => `${config.assetBase.replace(/\/$/, '')}/${path.replace(/^\//, '')}`;
